import { createBookingApiClient } from "@openings/api-client";

// ---------------------------------------------------------------------------
// Shared lazy API client for template components.
//
// Template components are bundled into multiple Next.js apps. They rely on
// `NEXT_PUBLIC_API_BASE` (build-time inlined) to reach the API. Each consumer
// used to inline this factory; it now lives here to keep behaviour consistent.
// ---------------------------------------------------------------------------

let cachedClient: ReturnType<typeof createBookingApiClient> | null = null;

export function getApiClient(): ReturnType<typeof createBookingApiClient> {
  if (!cachedClient) {
    const base =
      typeof process !== "undefined"
        ? process.env.NEXT_PUBLIC_API_BASE
        : undefined;
    if (!base) throw new Error("NEXT_PUBLIC_API_BASE is not set");
    cachedClient = createBookingApiClient(base.replace(/\/$/, ""));
  }
  return cachedClient;
}
